// extracted by mini-css-extract-plugin
module.exports = {"container":"Ep-z","disabled":"Fp-z","bgBlack":"Gp-z","content":"Hp-z","countdown":"Ip-z","topCaption":"Jp-z","topHeading":"Kp-z","heading":"Lp-z","copy":"Mp-z"};